import React from 'react';
import styles from './ClientBanner.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import { ALL_PRODUCTS, allProducts } from "./../API/ProductsAPI";

const ClientBanner = (props) => {

  const handleNavLink = () => {
    props.setActiveCategory(ALL_PRODUCTS)
    props.setProducts(allProducts);
  }

  return (
    <div className={styles.container}>
      <div className={styles.bannerContainer}>
        <div className={styles.textContainer}>
          <h2 className={styles.heading}>
            Peste <span className={styles.highlight}>50.000</span> de clienți folosesc produsele Altep pentru încălzire.
          </h2>
          <p className={styles.subText}>Casa ta se încălzește cu produsele Altep.</p>
        </div>
        <div className={styles.buttonContainer}>
          <NavLink to='/' className={styles.button} onClick={handleNavLink}>
            Vizualizați produsele <i className="fa-solid fa-circle-arrow-right" />
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default ClientBanner;
